import { FuoriSede, FusoOrario } from "./Interfaces";

const CONSTANTS = {
    labelFillAllRequiredFields: "Compilare tutti i campi obbligatori",
    internalUserRole : "interni",
    externalUserRole : "ldapesternistor",
    storInCompilazione : "In compilazione",
    storInviate : "Inviata",
    storRettificate : "Integrata",
    storCancellate : "Cancellata",
    storDaCompletare: "Da Completare",
    storCompletateL0 : "Chisura-L0",
    storCompletateL1 : "Chisura-L1"
}

export default CONSTANTS;

export const FUORI_SEDE: FuoriSede[] = [
    {
        id: 1,
        name: 'SI'
    },
    {
        id: 2, 
        name: 'NO'
    }
];

export const FUSO_ORARIO_LIST: FusoOrario[] = [
    {
        id: "UTC",
        name: "Universal Coordinated Time (UTC)"
    },
    {
        id: "GMT",
        name: "GMT (Greenwich Mean Time) (UTC)"
    },
    {
        id: "ECT",
        name: "European Central Time (UTC+1:00)"
    },
    {
        id: "EET",
        name: "EET (Eastern European Time) (UTC+2:00)"
    },
    {
        id: "ART",
        name: "ART (Egypt Standard Time Arabic) (UTC+2:00)"
    },
    {
        id: "EAT",
        name: "Eastern African Time (UTC+3:00)"
    },
    {
        id: "MET",
        name: "Middle East Time (UTC+3:30)"
    },
    {
        id: "NET",
        name: "Near East Time (UTC+4:00)"
    },
    {
        id: "PLT",
        name: "Pakistan Lahore Time (UTC+5:00)"
    },
    {
        id: "IST",
        name: "India Standard Time (UTC+5:30)"
    },
    {
        id: "BST",
        name: "Bangladesh Standard Time (UTC+6:00)"
    },
    {
        id: "VST",
        name: "Vietnam Standard Time (UTC+7:00)"
    },
    {
        id: "CTT",
        name: "China Taiwan Time (UTC+8:00)"
    },
    {
        id: "JST",
        name: "Japan Standard Time (UTC+9:00)"
    },
    {
        id: "ACT",
        name: "Australia Central Time (UTC+9:30)"
    },
    {
        id: "AET",
        name: "Australia Eastern Time (UTC+10:00)"
    },
    {
        id: "SST",
        name: "Solomon Standard Time (UTC+11:00)"
    },
    {
        id: "NST",
        name: "New Zealand Standard Time (UTC+12:00)"
    },
    {
        id: "MIT",
        name: "Midway Islands Time (UTC-11:00)"
    },
    {
        id: "HST",
        name: "Hawaii Standard Time (UTC-10:00)"
    },
    {
        id: "AST",
        name: "Alaska Standard Time (UTC-9:00)"
    },
    {
        id: "PST",
        name: "Pacific Standard Time (UTC-8:00)"
    },
    {
        id: "PNT",
        name: "Phoenix Standard Time (UTC-7:00)"
    },
    {
        id: "MST",
        name: "Mountain Standard Time (UTC-7:00)"
    },
    {
        id: "CST",
        name: "Central Standard Time (UTC-6:00)"
    },
    {
        id: "EST",
        name: "Eastern Standard Time (UTC-5:00)"
    },
    {
        id: "IET",
        name: "Indiana Eastern Standard Time (UTC-5:00)"
    },
    {
        id: "PRT",
        name: "Puerto Rico and US Virgin Islands Time (UTC-4:00)"
    },
    {
        id: "CNT",
        name: "Canada Newfoundland Time (UTC-3:30)"
    },
    {
        id: "AGT",
        name: "Argentina Standard Time (UTC-3:00)"
    },
    {
        id: "BET",
        name: "Brazil Eastern Time (UTC-3:00)"
    },
    {
        id: "CAT",
        name: "Central African Time (UTC-1:00)"
    }
]

export const GENERIC_HEADER = {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
    'X-Content-Type-Options': 'nosniff',
    "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
};

export const GENERIC_MULTIPART_HEADER = {
    'Content-Type': 'multipart/form-data',
    // 'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
    'X-Content-Type-Options': 'nosniff',
    "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
}